// extracted by mini-css-extract-plugin
export var addToCartToaster = "AddToCartToaster-module--addToCartToaster--36a2c";
export var close = "AddToCartToaster-module--close--e9cf7";
export var h3 = "AddToCartToaster-module--h3--34e37";
export var hideBackdrop = "AddToCartToaster-module--hideBackdrop--36f76";
export var topRow = "AddToCartToaster-module--topRow--baac1";